var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLuggage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1200pt",
    height: "1200pt",
    viewBox: "0 0 1200 1200",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m377 222.14h446v755.71h-446z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m700.02 377.73v44.453c0 12.273-9.9531 22.227-22.227 22.227h-155.59c-12.273 0-22.227-9.9531-22.227-22.227v-44.453h77.793v-111.14h-44.453c-12.273 0-22.227-9.9492-22.227-22.227 0-12.273 9.9531-22.227 22.227-22.227h133.36c12.273 0 22.227 9.9531 22.227 22.227 0 12.277-9.9531 22.227-22.227 22.227h-44.453v111.14zm44.453 0h33.34c24.551 0 44.453 19.902 44.453 44.453v422.31c0 24.551-19.902 44.457-44.453 44.457h-3.793c2.457 6.9492 3.793 14.43 3.793 22.227 0 36.824-29.855 66.68-66.68 66.68-36.828 0-66.68-29.855-66.68-66.68 0-7.7969 1.3359-15.277 3.793-22.227h-96.496c2.457 6.9492 3.793 14.43 3.793 22.227 0 36.824-29.852 66.68-66.68 66.68-36.828 0-66.68-29.855-66.68-66.68 0-7.7969 1.3359-15.277 3.793-22.227h-3.793c-24.551 0-44.453-19.906-44.453-44.457v-422.31c0-24.551 19.902-44.453 44.453-44.453h33.34v44.453c0 36.824 29.852 66.68 66.68 66.68h155.59c36.824 0 66.68-29.855 66.68-66.68zm-255.61 555.67c12.277 0 22.227-9.9531 22.227-22.227 0-12.277-9.9492-22.227-22.227-22.227-12.277 0-22.227 9.9492-22.227 22.227 0 12.273 9.9492 22.227 22.227 22.227zm222.27 0c12.273 0 22.227-9.9531 22.227-22.227 0-12.277-9.9531-22.227-22.227-22.227-12.277 0-22.227 9.9492-22.227 22.227 0 12.273 9.9492 22.227 22.227 22.227z",
    fill: "#01447a"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLuggage);
export default __webpack_public_path__ + "static/media/luggage.0de3b4dbab56bdb7e2e29f897bf43fc7.svg";
export { ForwardRef as ReactComponent };